module.exports = __webpack_public_path__ + "static/media/sameer.c66800de.jpg";